import {Directive, Input} from '@angular/core';
import {CustomValidationService} from '../services/custom-validation.service';
import {AbstractControl, NG_VALIDATORS} from '@angular/forms';

@Directive({
  selector: '[transferMaximumAmount]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MaximumAmountPatternDirective, multi: true }]
})
export class MaximumAmountPatternDirective {
  @Input('transferMaximumAmount') TransferMax: number;
  constructor(private customValidator: CustomValidationService) { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.customValidator.maximumAmountPatternValidator(this.TransferMax)(control);
  }

}